import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Search from '../views/Search.vue'
import Tasks from '../views/Tasks.vue'
import Analysis from '../views/Analysis.vue'
import Parser from '../views/Parser.vue'
import About from '../views/About.vue'
import Director from '../views/Director.vue'
import AccountAnalysis from '../views/AccountAnalysis.vue'
import LoginManagement from '../views/LoginManagement.vue'
import VideoCreation from '../views/VideoCreation.vue'
import Pricing from '../views/Pricing.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing
    },
    {
      path: '/parser',
      name: 'Parser',
      component: Parser
    },
    {
      path: '/director',
      name: 'Director',
      component: Director
    },
    {
      path: '/search',
      name: 'Search',
      component: Search
    },
    {
      path: '/tasks',
      name: 'Tasks',
      component: Tasks
    },
    {
      path: '/analysis/:taskId',
      name: 'Analysis',
      component: Analysis,
      props: true
    },
    {
      path: '/account-analysis',
      name: 'AccountAnalysis',
      component: AccountAnalysis
    },
    {
      path: '/login-management',
      name: 'LoginManagement',
      component: LoginManagement
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/video-creation',
      name: 'VideoCreation',
      component: VideoCreation
    },
    {
      path: '/download-preview',
      name: 'DownloadPreview',
      component: () => import('../views/DownloadPreview.vue')
    },
    {
      path: '/subtitle-remover',
      name: 'SubtitleRemover',
      component: () => import('../views/SubtitleRemover.vue')
    }
  ]
})

export default router


